import { tv } from 'tailwind-variants';

export const listItemVariants = tv({
  slots: {
    root: 'relative inline-flex shrink-0 items-center justify-center whitespace-nowrap',
    content: 'flex-grow flex flex-col justify-center items-start',
    label: 'text-sm',
    description: 'text-sm text-shade-40',
  },

  variants: {
    kind: {
      list: {
        root: 'gap-xs',
      },
      custom: {
        root: 'py-2xs',
      },
    },

    size: {
      small: { root: 'px-sm py-3xs' },
      default: { root: 'px-sm py-xs' },
    },

    selected: {
      true: { root: 'bg-status-selected' },
      false: { root: '' },
    },

    disabled: {
      true: {
        root: 'text-status-disabled-dark select-none',
      },
      false: { root: 'hover:bg-state-hover' },
    },

    as: {
      button: { root: '' },
      a: { root: 'text-element-secondary' },
      link: { root: 'text-element-secondary' },
      div: { root: '' },
    },
  },

  compoundVariants: [
    {
      selected: true,
      disabled: false,
      class: { root: 'text-status-selected' },
    },
  ],

  defaultVariants: {
    kind: 'list',
    size: 'default',
    selected: false,
    disabled: false,
    as: 'div',
  },
});
